
<template>

  <div class="search-outer" style="height:94%;">

    <div
      class="ob-input-box"
      v-if="!['type', 'altConfig', 'fType'].includes(input.val)"
    >
      <input class="ob-input" v-model="searchInput"  />
      <label class="ob-label" style="text-align:center;" v-if="input.val !== 'type'">{{clauses[input.label]}}</label>
    </div>

    <div class="search-body">
      <div
        class="search-node"
        v-for="i in fulfillSearch(input.val)"
        @click="$emit('setSearchedItem', i.code ? i.code : i.val)"
        v-if="input.val === 'country' || input.val === 'altConfig'"
        :style="{'padding': input.val === 'country' ? '' : '0px'}"
      >
        <h3 v-if="input.val === 'country'">{{truncate(i.name, 20)}}</h3>
        <img v-if="input.val === 'country'" class="flag-img" :src="i.code ? setFlag(i.code) : ''" />
        <h3 v-if="input.val === 'altConfig'" class="search-node-head">{{i.val}}</h3>
        <h6 v-if="input.val === 'altConfig'" style="margin-right:5%;">{{truncate(i.text, 20)}}</h6>
      </div>

      <div
        class="search-node text-search-node"
        v-for="i in fulfillSearch(input.val)"
        @click="setCityState(i)"
        v-if="input.val === 'city' || input.val === 'type'"
      >
        <h3 class="search-node-head" v-if="i.city">{{truncate(i.city, 15)}}</h3>
        <h3 style="color:rgb(0,153,191)" v-if="i.city">{{i.state ? truncate(i.state, 15) : ''}}</h3>
        <h3 v-if="!i.city" class="search-node-head" v-html="i">{{i}}</h3>
        <img v-if="!i.city" :src="parseImg(i)" />
      </div>
      <div
        class="search-node text-search-node filter-search-node"
        v-for="i in fulfillSearch(input.val)"
        v-if="input.val === 'fType'"
        @click="$emit('setSearchedItem', i)">
        <h3>{{i}}</h3>
      </div>
    </div>
  </div>

</template>

<script>

  import { hasFlag } from 'country-flag-icons';

  export default {

    data(){
      return {
        searchInput: ''
      }
    },

    props: ['input'],

    computed: {
      clauses(){
        let lPref = this.$store.state.lang;
        let lang;
        switch (this.$store.state.onboard.obEntity) {
          case 'access':
            lang = 'RequestAccessTemplate';
          break;
          case 'bldg':
            lang = 'OnboardBuildingTemplate';
          break;
          case 'room':
            lang = 'OnboardRoomTemplate';
          break;
          case 'user':
            lang = 'OnboardUserComponent';
          break;
        }
        const Lang = require(`@/lib/langTemplates/${lang}`);
        return Object.keys(Lang.clauses).reduce((a, i) => {
          a[i] = Lang.clauses[i][lPref];
          return a;
        }, {});
      }
    },

    methods: {

      fulfillSearch(val){
        let getter = `getSearched${val[0].toUpperCase() + val.substring(1, val.length)}`;
        if (getter === 'getSearchedType') {
          return [
            this.clauses.hotel,
            this.clauses.office,
            this.clauses.apts,
            this.clauses.other
          ]
        } else if (getter === 'getSearchedAltConfig') {
          return [
            {
              val: 'FCU',
              text: this.clauses.fcu
            },
            {
              val: 'AHU',
              text: this.clauses.ahu
            },
            {
              val: 'VRF',
              text: this.clauses.vrf
            },
            {
              val: 'PTAC',
              text: this.clauses.ptac
            },
            {
              val: 'VTAC',
              text: this.clauses.vtac
            },
            {
              val: 'RTU',
              text: this.clauses.rtu
            },
            {
              val: 'SPLIT',
              text: this.clauses.split
            },
            {
              val: 'OTHER',
              text: this.clauses.other
            }
          ]
        } else if (getter === 'getSearchedFType') {
          return [
            this.clauses.hepa,
            this.clauses.panel,
            this.clauses.foam,
            this.clauses.bag,
            this.clauses.mediaRoll,
            this.clauses.other
          ]
        } else {
          return this.$store.getters[getter](this.searchInput);
        }
      },

      setFlag(c){
        if (hasFlag(c)) return `https://catamphetamine.github.io/country-flag-icons/3x2/${c}.svg`;
      },

      parseImg(i){
        let img;
        switch (i) {
          case this.clauses.hotel:
            img = 'hotel';
          break;
          case this.clauses.office:
            img = 'office';
          break;
          case this.clauses.apts:
            img = 'apartment';
          break;
          case this.clauses.other:
            img = 'company';
          break;
        }
        return `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${img}.png`;
      },

      truncate(str, limit){
        return str.length < limit ? str : str.substring(0, limit - 3) + '...';
      },

      setCityState(i){
        this.$store.dispatch('setBuildingState', i.state ? i.state : ' ');
        this.$emit('setSearchedItem', i.city ? i.city : i);
        this.$store.dispatch('setCountryCities', this.$store.state.onboard.obPacket.country ? this.$store.state.onboard.obPacket.country : '');
      }

    }

  }

</script>

<style>

.text-search-node {
  min-height: 55px;
  max-height: 55px;
  display: flex;
  justify-content: space-between;
  padding: 0px;
  padding-right: 5%;
}

.search-node-head {
  background-color: rgb(0, 153, 191);
  width: 40%;
  min-height: 55px;
  max-height: 55px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-search-node img {
  height: 45px;
}

.filter-search-node {
  justify-content: center;
}

.filter-search-node:hover {
  background-color: rgb(0, 153, 191);
}

</style>



// WEBPACK FOOTER //
// src/components/onboard/SearchList.vue